import { Node, ReactNodeViewRenderer } from '@tiptap/react';
import ZyFootnoteNodeView from './zyfootnote-node-view';

export interface ZyFootnoteAttributes {
    id: string;
    number: string;
}

export interface InsertFootnoteOptions {
    number: string;
    content?: any[];
}

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zyFootnote: {
            insertZyFootnote: (options: InsertFootnoteOptions) => ReturnType;
        };
    }
}

export const ZyFootnoteHeadless = Node.create({
    name: 'zyFootnote',

    group: 'inline',

    inline: true,

    content: 'inline*',

    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => element.getAttribute('id'),
                renderHTML: attributes => {
                    if (attributes.id) {
                        return { id: attributes.id };
                    }
                    return {};
                },
            },
            number: {
                default: '',
                parseHTML: element => element.getAttribute('name'),
                renderHTML: attributes => {
                    if (attributes.number) {
                        return { name: attributes.number };
                    }
                    return {};
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'zyFootnote',
            },
        ];
    },

    renderHTML({ node }) {
        return [
            'zyFootnote',
            {
                id: node.attrs.id,
                name: node.attrs.number,
            },
            0,
        ];
    },

    addCommands() {
        return {
            insertZyFootnote:
                (options: InsertFootnoteOptions) =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: this.name,
                        attrs: {
                            number: options.number,
                        },
                        content: options.content || [{ type: 'text', text: 'Footnote reference...' }],
                    });
                },
        };
    },
});

export const ZyFootnote = ZyFootnoteHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyFootnoteNodeView);
    },
});

export default ZyFootnote;
